/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

export function getDisplayName(Component: React.ComponentType<any>): string {
  return Component.displayName || Component.name || 'Component';
}
